import Masonry from 'masonry-layout';

let msnry = null;

const masonryBlogTeaser = function () {
  const grid = document.querySelector('.masonry-grid');
  if (!grid) return;

  const initMasonry = () => {
    // falls schon vorhanden, nicht doppelt initialisieren
    if (msnry) msnry.destroy();

    msnry = new Masonry(grid, {
      itemSelector: '.masonry-item',
      columnWidth: '.masonry-sizer',
      percentPosition: true,
      horizontalOrder: true,      // hält Reihenfolge stabiler
      transitionDuration: '0.25s' // Bewegung weich machen
    });
    window.msnry = msnry;
  };

  const relayoutMasonry = () => {
    if (window.msnry) window.msnry.layout();
  };

  const initReadMore = () => {
    grid.querySelectorAll('.js-review-text[data-long="1"]').forEach((wrap) => {
      // prevent double-binding
      if (wrap.dataset.rmBound === '1') return;
      wrap.dataset.rmBound = '1';

      const btn = wrap.querySelector('.js-read-more');
      const excerpt = wrap.querySelector('.js-excerpt');
      const full = wrap.querySelector('.js-full');
      if (!btn || !excerpt || !full) return;

      btn.addEventListener('click', (e) => {
        // wichtig: weil Button im <a> steckt
        e.preventDefault();
        e.stopPropagation();

        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          full.classList.add('hidden');
          excerpt.classList.remove('hidden');
          btn.textContent = 'Read more';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          excerpt.classList.add('hidden');
          full.classList.remove('hidden');
          btn.textContent = 'Read less';
          btn.setAttribute('aria-expanded', 'true');
        }

        // DOM ist jetzt geändert -> Masonry neu berechnen
        requestAnimationFrame(relayoutMasonry);
      });
    });
  };

  // initial
  initMasonry();
  initReadMore();

  // global callable (du nutzt zwar kein Alpine mehr, aber Filter bleibt so nutzbar)
  window.masonryFilter = (filter) => {
    const items = grid.querySelectorAll('.masonry-item');

    items.forEach((item) => {
      const company = item.dataset.company;
      item.style.display = (filter === 'all' || company === filter) ? '' : 'none';
    });

    // Masonry neu aufbauen, weil sich sichtbare Items ändern
    initMasonry();

    // optional: falls in gefilterten Items ReadMore Buttons sind
    initReadMore();
  };
};

export { masonryBlogTeaser };
